
const LINK_SETTINGS = "/app/settings";


export const SETTINGS_GROUP_LINKS = {
	BASE: LINK_SETTINGS,
};